module.exports = __webpack_public_path__ + "img/7.fa58e476.jpg";